export enum PlatformType {
    Tizen = "Tizen",
    WebOS = "WebOS",
    Browser = "Browser",
    Amazon = "Amazon",
}